// Thin fetch wrapper targeting the backend API.
// In dev (vite on :5173) calls go through Vite proxy or directly to :3001 if configured.
// In prod, Nginx serves both, so relative URLs always work.

const API_BASE = import.meta.env.VITE_API_BASE || '';

async function req(path, { method = 'GET', body, isForm = false } = {}) {
  const opts = {
    method,
    credentials: 'include',
    headers: {},
  };
  if (body !== undefined) {
    if (isForm) {
      opts.body = body;
    } else {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
  }
  const res = await fetch(API_BASE + path, opts);
  const ct  = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json().catch(() => null) : null;
  if (!res.ok) {
    const err = new Error(data?.error || `http_${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const api = {
  health:        ()            => req('/api/health'),
  getContent:    ()            => req('/api/content'),
  putContent:    (content)     => req('/api/content', { method: 'PUT', body: { content } }),
  authStatus:    ()            => req('/api/auth/status'),
  login:         (password)    => req('/api/auth/login', { method: 'POST', body: { password } }),
  logout:        ()            => req('/api/auth/logout', { method: 'POST' }),
  changePassword:(current, next) => req('/api/auth/password', { method: 'POST', body: { current, next } }),
  upload:        (file)        => {
    const fd = new FormData();
    fd.append('file', file);
    return req('/api/upload', { method: 'POST', body: fd, isForm: true });
  },
};

// Helper — detect whether the backend is reachable.
export async function backendReachable() {
  try { await api.health(); return true; } catch { return false; }
}
